import { ButtonProps } from './types';
import {
  ButtonVariantCanonical,
  ButtonVariantLegacy,
} from './types/button-variant';

const LEGACY_VARIANT_MAP = {
  tertiary: 'naked',
} as const satisfies Record<ButtonVariantLegacy, ButtonVariantCanonical>;

const normalizeVariantValue = (
  variant: string | null | undefined
): string | null | undefined => {
  if (variant == null) return variant;

  return Object.prototype.hasOwnProperty.call(LEGACY_VARIANT_MAP, variant)
    ? LEGACY_VARIANT_MAP[variant as ButtonVariantLegacy]
    : variant;
};

export function normalizeVariant(
  variant: ButtonProps['variant']
): ButtonProps['variant'] {
  if (variant == null) return variant;

  if (typeof variant === 'string') {
    return normalizeVariantValue(variant) as ButtonProps['variant'];
  }

  if (Array.isArray(variant)) {
    return variant.map((value) =>
      normalizeVariantValue(value)
    ) as ButtonProps['variant'];
  }

  // Responsive object (e.g. { base: 'tertiary', md: 'primary' })
  return Object.fromEntries(
    Object.entries(variant).map(([bp, v]) => [bp, normalizeVariantValue(v)])
  ) as ButtonProps['variant'];
}
